import React, { useEffect } from "react";

import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

const KoppelenDiscipline = () => {
  useEffect(() => {
    $("#koppelen_discipline").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_DISCIPLINE,
        1,
        30,
        CallBackFunctions.DisciplineCallback,
        window.$catalog_management_units_token
      );
    });
  });

  const handleClick = () => {
    $("#cover-spin").show(0);
    var disciplineId = $("input[name=discipline]:checked").attr("id");
    var element = $("input[name=discipline]:checked");
    var label = $(element).next("label").attr("for", disciplineId);
    var model = {
      datum: "2020-12-01T12:00:00.001Z",
      discipline: {
        identification: disciplineId,
        "$.name": label[0].innerText,
      },
    };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "ac2c02c3-b545-42df-88dd-16abc83c01fc",
      disciplineSaved,
      window.$catalog_management_units_token
    );
    function disciplineSaved() {
      GC.sleep(500).then(() => {
        $("#koppelen_discipline").modal("hide");
        window.$catalog_measures_refresh();
        /*omnimap
          .FillTableAction(
            window.$catalog_measures_last_used_table_filter,
            1,
            window.$catalog_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillTableCallBack(result, 1);
          });*/
      });
    }
  };

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="koppelen_discipline"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Selecteren discipline</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input type="search" className="modal-search" placeholder="" />
            <div className="modal-scroll">
              <div id="discipline-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="measures_save_discipline"
              className="btn-modal"
              onClick={handleClick}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KoppelenDiscipline;
